import { gql } from '@apollo/client';

export default gql`
  query spaceBilling {
    plans {
      plans {
        id
        name
        price
        billingInterval
        billingIntervalType
        placesLimit
        inspectionSubjectsLimit
        inspectionsLimit
        canSet
      }
    }
    space {
      activePlanEndDate
      activePlan {
        id
        name
        price
        billingInterval
        placesLimit
        inspectionSubjectsLimit
        inspectionsLimit
      }
      billingDetails {
        id
        name
        address
        city
        zipCode
        taxId
        email
      }
      inspectionsTotal
      pendingInspectionsTotal
      inspectionSubjectsTotal
      placesTotal
    }
  }
`;
